function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EE224D",
  d: "M0,80C0,35.817,35.817,0,80,0s80,35.817,80,80s-35.817,80-80,80S0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M85.656,80l21.416-21.416c1.563-1.563,1.563-4.095,0-5.656c-1.562-1.563-4.095-1.563-5.657,0L80,74.344 L58.584,52.928c-1.563-1.563-4.095-1.563-5.656,0c-1.563,1.562-1.563,4.094,0,5.656L74.344,80l-21.416,21.416 c-1.563,1.563-1.563,4.095,0,5.656c0.78,0.781,1.804,1.172,2.829,1.172c1.022,0,2.046-0.391,2.827-1.172L80,85.657l21.415,21.415 c0.781,0.781,1.805,1.172,2.829,1.172c1.023,0,2.047-0.391,2.828-1.172c1.563-1.562,1.563-4.094,0-5.656L85.656,80z"
});

var SvgErroreAccent = function SvgErroreAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.665 -0.435 161 161",
    enableBackground: "new -0.665 -0.435 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErroreAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/errore_accent.ff8ccfa7.svg";
export { ForwardRef as ReactComponent };